(function () {
  'use strict';

  var form = document.getElementById('neon-offerte-form');
  if (!form) return;

  /* ==========================================================================
     CONSTANTS & STATE
     ========================================================================== */

  var PARTIAL_API = 'https://offerte.bonfireclub.eu/api/leads/partial';
  var SUBMIT_API  = 'https://offerte.bonfireclub.eu/api/leads/submit';
  var UPLOAD_URL_API = 'https://offerte.bonfireclub.eu/api/leads/upload-url';
  var STORAGE_KEY = 'bf_partial_lead_id';

  var ALLOWED_TYPES = [
    'image/jpeg', 'image/png', 'image/gif', 'image/svg+xml',
    'application/pdf', 'application/postscript', 'application/illustrator',
    'application/octet-stream'
  ];
  var ALLOWED_EXT = /\.(jpg|jpeg|png|gif|svg|pdf|ai|eps)$/i;
  var MAX_FILE_SIZE = 50 * 1024 * 1024;

  var partialLeadId  = sessionStorage.getItem(STORAGE_KEY) || '';
  var partialTimer   = null;
  var formSubmitted  = false;
  var selectedFile   = null;
  var uploadedFileUrl = '';
  var fileUploading  = false;

  /* ==========================================================================
     PARTIAL SAVE — Abandoned Form Tracking
     ========================================================================== */

  // Attributie (UTM's + click-ID's) vastgelegd door snippets/neon-attribution.liquid
  var ATTRIBUTION_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    'gclid', 'fbclid', 'ttclid', 'msclkid', 'landing_page', 'referrer'
  ];

  function getAttribution() {
    try {
      var raw = localStorage.getItem('bf_attribution');
      return raw ? (JSON.parse(raw) || {}) : {};
    } catch (e) { return {}; }
  }

  // Eén naamveld in de UI, maar de API/CAPI verwacht voornaam (fn) en
  // achternaam (ln) gesplitst: eerste woord = voornaam, rest = achternaam.
  function splitNaam() {
    var full = (form.querySelector('[name="naam"]')?.value || '').trim().replace(/\s+/g, ' ');
    if (!full) return { voornaam: '', achternaam: '' };
    var parts = full.split(' ');
    return { voornaam: parts[0], achternaam: parts.slice(1).join(' ') };
  }

  function getFormSnapshot() {
    var checkedDoelgroep = form.querySelector('[name="doelgroep"]:checked');
    var checkedType      = form.querySelector('[name="neon_type"]:checked');
    var checkedLoc       = form.querySelector('[name="locatie"]:checked');
    var checkedTiming    = form.querySelector('[name="timing"]:checked');

    var snapshot = {
      lead_id:          partialLeadId,
      doelgroep:        checkedDoelgroep ? checkedDoelgroep.value : '',
      neon_type:        checkedType      ? checkedType.value      : '',
      neon_tekst:       (form.querySelector('[name="neon_tekst"]')?.value  || '').trim(),
      locatie:          checkedLoc       ? checkedLoc.value       : '',
      timing:           checkedTiming    ? checkedTiming.value    : '',
      afmeting:         (function () {
        var sel = form.querySelector('[name="afmeting"]');
        var val = sel ? sel.value : '';
        if (val === 'Anders') {
          var custom = (form.querySelector('[name="afmeting_anders"]')?.value || '').trim();
          return custom ? custom + 'cm' : 'Anders';
        }
        return val;
      })(),
      voornaam:         splitNaam().voornaam,
      achternaam:       splitNaam().achternaam,
      email:            (form.querySelector('[name="email"]')?.value           || '').trim(),
      telefoon_prefix:   form.querySelector('[name="telefoon_prefix"]')?.value || '',
      telefoon:         (form.querySelector('[name="telefoon"]')?.value        || '').trim(),
      bedrijfsnaam:     (form.querySelector('[name="bedrijfsnaam"]')?.value    || '').trim(),
      wensen:           (form.querySelector('[name="wensen"]')?.value          || '').trim(),
      bron: 'neon-sign-landing'
    };

    if (uploadedFileUrl) snapshot.file_url  = uploadedFileUrl;
    if (selectedFile)    snapshot.file_name = selectedFile.name;

    var logoLaterCb = document.getElementById('neon-upload-later');
    if (logoLaterCb && logoLaterCb.checked) snapshot.logo_later = 'Ja';

    var attribution = getAttribution();
    ATTRIBUTION_KEYS.forEach(function (k) {
      if (attribution[k]) snapshot[k] = attribution[k];
    });

    return snapshot;
  }

  function hasMinimumData(snap) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(snap.email) || snap.telefoon.length > 0;
  }

  function sendPartialSave(useBeacon) {
    if (formSubmitted) return;
    var snap = getFormSnapshot();
    if (!hasMinimumData(snap)) return;
    var body = JSON.stringify(snap);
    if (useBeacon && navigator.sendBeacon) {
      navigator.sendBeacon(PARTIAL_API, new Blob([body], { type: 'application/json' }));
      return;
    }
    fetch(PARTIAL_API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.lead_id) {
          partialLeadId = data.lead_id;
          sessionStorage.setItem(STORAGE_KEY, partialLeadId);
        }
      })
      .catch(function () {});
  }

  function debouncedPartialSave() {
    clearTimeout(partialTimer);
    partialTimer = setTimeout(function () { sendPartialSave(false); }, 1500);
  }

  // Debounced partial save on all inputs
  form.querySelectorAll('input, textarea, select').forEach(function (field) {
    field.addEventListener('input',  debouncedPartialSave);
    field.addEventListener('change', debouncedPartialSave);
  });

  window.addEventListener('beforeunload', function () { sendPartialSave(true); });

  /* ==========================================================================
     FORM START — micro-conversie bij eerste veldinteractie
     ========================================================================== */

  var formStartFired = false;
  function fireFormStart() {
    if (formStartFired) return;
    formStartFired = true;
    if (typeof fbq === 'function') {
      fbq('trackCustom', 'FormStart', { content_name: 'Neon Sign Aanvraag' });
    }
    if (typeof gtag === 'function') {
      gtag('event', 'form_start', { form_id: 'neon-offerte-form', form_name: 'Neon Sign Aanvraag' });
    }
  }
  form.addEventListener('input',  fireFormStart);
  form.addEventListener('change', fireFormStart);

  /* ==========================================================================
     CONDITIONAL LOGIC — Show/hide velden op basis van selecties
     ========================================================================== */

  // Tekst-leads zien standaard alleen de designer-CTA; via de secundaire
  // link kunnen ze alsnog het offerteformulier openen.
  var tekstFormOverride = false;

  function updateConditionalFields() {
    var neonTypeVal  = (form.querySelector('[name="neon_type"]:checked')  || {}).value;
    var doelgroepVal = (form.querySelector('[name="doelgroep"]:checked') || {}).value;
    var isTekst = neonTypeVal === 'Tekst';
    var isLogo  = neonTypeVal === 'Logo';

    if (!isTekst) tekstFormOverride = false;

    // Veld 3a: upload (alleen bij Logo)
    var uploadGroup = document.getElementById('neon-upload-group');
    if (uploadGroup) uploadGroup.style.display = isLogo ? '' : 'none';

    // Veld 3b: tekst textarea — alleen zichtbaar als een tekst-lead het formulier opent
    var tekstGroup = document.getElementById('neon-tekst-group');
    if (tekstGroup) tekstGroup.style.display = (isTekst && tekstFormOverride) ? '' : 'none';

    // Tekst-redirect CTA (alleen zichtbaar bij Tekst, tot het formulier is geopend)
    var tekstRedirect = document.getElementById('neon-tekst-redirect');
    if (tekstRedirect) tekstRedirect.style.display = (isTekst && !tekstFormOverride) ? '' : 'none';

    // Hoofdvelden 4 t/m submit — verborgen bij Tekst zonder override
    var mainFields = document.getElementById('neon-form-main-fields');
    if (mainFields) mainFields.style.display = (isTekst && !tekstFormOverride) ? 'none' : '';

    // Veld 7d: bedrijfsnaam (alleen bij "Voor mijn bedrijf")
    var bedrijfGroup = document.getElementById('neon-bedrijf-group');
    if (bedrijfGroup) bedrijfGroup.style.display = doelgroepVal === 'Voor mijn bedrijf' ? '' : 'none';

    // Telefoon: alleen verplicht voor zakelijke aanvragen — toon dit in de placeholder
    var telInput = form.querySelector('[name="telefoon"]');
    if (telInput) {
      if (!telInput.dataset.basePlaceholder) telInput.dataset.basePlaceholder = telInput.placeholder;
      telInput.placeholder = doelgroepVal === 'Voor mijn bedrijf'
        ? telInput.dataset.basePlaceholder
        : telInput.dataset.basePlaceholder + ' (optioneel)';
    }
  }

  /* ==========================================================================
     TOGGLE CARD HANDLERS — Klikbare radio kaarten
     ========================================================================== */

  // Doelgroep — paars
  initCardToggle('neon-doelgroep-toggle', 'is-active--purple', updateConditionalFields);

  // Neon type — paars
  initCardToggle('neon-type-toggle', 'is-active--purple', updateConditionalFields);

  // Locatie — groen
  initCardToggle('neon-location-toggle', 'is-active', null);

  // Timing — groen
  initTimingToggle('neon-timing-toggle');

  // Secundaire link: tekst-lead wil tóch een offerte op maat
  var tekstShowFormBtn = document.getElementById('neon-tekst-show-form');
  if (tekstShowFormBtn) {
    tekstShowFormBtn.addEventListener('click', function () {
      tekstFormOverride = true;
      updateConditionalFields();
      var tekstInput = document.getElementById('neon-tekst-input');
      if (tekstInput) tekstInput.focus();
    });
  }

  // Initiële staat van conditionele velden (o.a. telefoon-placeholder)
  updateConditionalFields();

  function initCardToggle(containerId, activeClass, onChange) {
    var container = document.getElementById(containerId);
    if (!container) return;
    var options = container.querySelectorAll('.neon-form__toggle-option');
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) {
          o.classList.remove('is-active', 'is-active--purple');
        });
        opt.classList.add(activeClass);
        var radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        if (onChange) onChange();
        debouncedPartialSave();
      });
    });
  }

  function initTimingToggle(containerId) {
    var container = document.getElementById(containerId);
    if (!container) return;
    var options = container.querySelectorAll('.neon-form__timing-option');
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        var radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        debouncedPartialSave();
      });
    });
  }

  /* ==========================================================================
     AFMETING — "Anders" toggle
     ========================================================================== */

  var afmetingSelect = document.getElementById('neon-afmeting');
  var andersWrap     = document.getElementById('neon-anders-wrap');
  var andersInput    = document.getElementById('neon-afmeting-anders');

  if (afmetingSelect && andersWrap) {
    afmetingSelect.addEventListener('change', function () {
      if (afmetingSelect.value === 'Anders') {
        andersWrap.style.display = '';
        andersInput.focus();
      } else {
        andersWrap.style.display = 'none';
        andersInput.value = '';
      }
    });
  }

  /* ==========================================================================
     FILE UPLOAD — Selecteren, preview & direct uploaden naar Supabase
     ========================================================================== */

  var fileInput      = document.getElementById('neon-file-input');
  var uploadArea     = document.getElementById('neon-upload-area');
  var uploadBtn      = document.getElementById('neon-upload-btn');
  var uploadPreview  = document.getElementById('neon-upload-preview');
  var uploadThumb    = document.getElementById('neon-upload-thumb');
  var uploadName     = document.getElementById('neon-upload-name');
  var uploadRemove   = document.getElementById('neon-upload-remove');

  if (uploadBtn) {
    uploadBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      fileInput.click();
    });
  }

  if (uploadArea) {
    uploadArea.addEventListener('click', function () { fileInput.click(); });

    uploadArea.addEventListener('dragover', function (e) {
      e.preventDefault();
      uploadArea.classList.add('is-dragover');
    });

    uploadArea.addEventListener('dragleave', function () {
      uploadArea.classList.remove('is-dragover');
    });

    uploadArea.addEventListener('drop', function (e) {
      e.preventDefault();
      uploadArea.classList.remove('is-dragover');
      if (e.dataTransfer.files.length) handleFile(e.dataTransfer.files[0]);
    });
  }

  if (fileInput) {
    fileInput.addEventListener('change', function () {
      if (fileInput.files.length) handleFile(fileInput.files[0]);
    });
  }

  function handleFile(file) {
    var validMime = ALLOWED_TYPES.includes(file.type);
    var validExt  = ALLOWED_EXT.test(file.name);

    if (!validMime && !validExt) {
      showFieldError('file', 'Dit bestandstype is niet toegestaan. Gebruik JPG, PNG, PDF, AI, SVG of EPS.');
      return;
    }
    if (file.size > MAX_FILE_SIZE) {
      showFieldError('file', 'Bestand is te groot (max 50 MB).');
      return;
    }

    selectedFile = file;
    uploadedFileUrl = '';
    hideFieldError('file');

    // Preview: alleen voor afbeeldingen (geen PDF/AI/EPS)
    var isImage = file.type.startsWith('image/') && file.type !== 'image/svg+xml';
    if (isImage) {
      var reader = new FileReader();
      reader.onload = function (e) {
        uploadThumb.src = e.target.result;
        uploadThumb.style.display = '';
      };
      reader.readAsDataURL(file);
    } else {
      uploadThumb.src = '';
      uploadThumb.style.display = 'none';
    }

    uploadName.textContent = file.name;
    uploadPreview.classList.add('is-visible');
    uploadArea.style.display = 'none';

    // Direct uploaden naar Supabase via signed URL
    uploadFileToApi(file);
  }

  function uploadFileToApi(file) {
    fileUploading = true;
    uploadPreview.classList.add('is-uploading');

    fetch(UPLOAD_URL_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: file.name, contentType: file.type })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to get upload URL');
        return res.json();
      })
      .then(function (data) {
        return fetch(data.signedUrl, {
          method: 'PUT',
          headers: { 'Content-Type': file.type },
          body: file
        }).then(function (uploadRes) {
          if (!uploadRes.ok) throw new Error('Upload mislukt');
          return data.publicUrl;
        });
      })
      .then(function (publicUrl) {
        uploadedFileUrl = publicUrl;
        sendPartialSave(false);
      })
      .catch(function (err) {
        console.error('File upload error:', err);
        showFieldError('file', 'Upload mislukt. Probeer opnieuw.');
      })
      .finally(function () {
        fileUploading = false;
        uploadPreview.classList.remove('is-uploading');
      });
  }

  var uploadLaterCb = document.getElementById('neon-upload-later');
  if (uploadLaterCb) {
    uploadLaterCb.addEventListener('change', function () {
      if (uploadLaterCb.checked) hideFieldError('file');
    });
  }

  if (uploadRemove) {
    uploadRemove.addEventListener('click', function () {
      selectedFile    = null;
      uploadedFileUrl = '';
      if (fileInput) fileInput.value = '';
      uploadPreview.classList.remove('is-visible', 'is-uploading');
      uploadArea.style.display = '';
      uploadThumb.src = '';
      uploadThumb.style.display = '';
    });
  }

  /* ==========================================================================
     VALIDATIE
     ========================================================================== */

  function showFieldError(field, message) {
    var el = document.getElementById('neon-error-' + field);
    if (!el) return;
    if (message) el.textContent = message;
    el.classList.add('is-visible');
  }

  function hideFieldError(field) {
    var el = document.getElementById('neon-error-' + field);
    if (el) el.classList.remove('is-visible');
  }

  function hideAllErrors() {
    document.querySelectorAll('.neon-form__field-error').forEach(function (el) {
      el.classList.remove('is-visible');
    });
    var errorMsg = document.getElementById('neon-form-error');
    if (errorMsg) errorMsg.classList.remove('is-visible');
  }

  function validateForm() {
    var valid = true;
    hideAllErrors();

    // Veld 1: doelgroep
    if (!form.querySelector('[name="doelgroep"]:checked')) {
      showFieldError('doelgroep');
      valid = false;
    }

    // Veld 2: neon_type
    var neonType = form.querySelector('[name="neon_type"]:checked');
    if (!neonType) {
      showFieldError('neon_type');
      valid = false;
    }

    // Veld 3a/3b: bestand of tekst
    if (neonType) {
      if (neonType.value === 'Logo') {
        var logoLater = document.getElementById('neon-upload-later');
        if (!selectedFile && !uploadedFileUrl && !(logoLater && logoLater.checked)) {
          showFieldError('file');
          valid = false;
        }
      } else if (neonType.value === 'Tekst') {
        var tekstVal = (form.querySelector('[name="neon_tekst"]')?.value || '').trim();
        if (!tekstVal) {
          showFieldError('neon_tekst');
          valid = false;
        }
      }
    }

    // Veld 4: afmeting
    var afmetingVal = form.querySelector('[name="afmeting"]')?.value || '';
    if (!afmetingVal) {
      showFieldError('afmeting');
      valid = false;
    } else if (afmetingVal === 'Anders') {
      var customVal = (form.querySelector('[name="afmeting_anders"]')?.value || '').trim();
      if (!customVal) {
        showFieldError('afmeting', 'Vul je gewenste breedte in.');
        valid = false;
      }
    }

    // Veld 6: timing
    if (!form.querySelector('[name="timing"]:checked')) {
      showFieldError('timing');
      valid = false;
    }

    // Veld 7a: naam (voor- én achternaam nodig voor de offerte/CAPI)
    var naam = splitNaam();
    if (!naam.voornaam || !naam.achternaam) {
      showFieldError('naam');
      valid = false;
    }

    // Veld 7b: email
    var emailVal = (form.querySelector('[name="email"]')?.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
      showFieldError('email');
      valid = false;
    }

    var doelgroepVal = (form.querySelector('[name="doelgroep"]:checked') || {}).value;

    // Veld 7c: telefoon (alleen verplicht voor zakelijke aanvragen)
    if (doelgroepVal === 'Voor mijn bedrijf' && !(form.querySelector('[name="telefoon"]')?.value || '').trim()) {
      showFieldError('telefoon');
      valid = false;
    }

    // Veld 7d: bedrijfsnaam (alleen verplicht als doelgroep = "Voor mijn bedrijf")
    if (doelgroepVal === 'Voor mijn bedrijf') {
      if (!(form.querySelector('[name="bedrijfsnaam"]')?.value || '').trim()) {
        showFieldError('bedrijfsnaam');
        valid = false;
      }
    }

    return valid;
  }

  /* ==========================================================================
     FORM SUBMIT
     ========================================================================== */

  var submitBtn = document.getElementById('neon-submit-btn');
  var errorMsg  = document.getElementById('neon-form-error');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validateForm()) return;

    formSubmitted = true;
    submitBtn.classList.add('is-loading');
    submitBtn.disabled = true;

    var formData = new FormData();

    // Bestand of URL
    if (uploadedFileUrl) {
      formData.append('file_url', uploadedFileUrl);
    } else if (selectedFile) {
      formData.append('bestand', selectedFile);
    }
    var logoLaterSubmit = document.getElementById('neon-upload-later');
    if (logoLaterSubmit && logoLaterSubmit.checked) formData.append('logo_later', 'Ja');

    // Veld 1: doelgroep
    var doelgroep = form.querySelector('[name="doelgroep"]:checked');
    formData.append('doelgroep', doelgroep ? doelgroep.value : '');

    // Veld 2: neon_type
    var neonTypeChecked = form.querySelector('[name="neon_type"]:checked');
    formData.append('neon_type', neonTypeChecked ? neonTypeChecked.value : '');

    // Veld 3b: neon_tekst (alleen bij Tekst)
    if (neonTypeChecked && neonTypeChecked.value === 'Tekst') {
      formData.append('neon_tekst', (form.querySelector('[name="neon_tekst"]')?.value || '').trim());
    }

    // Veld 4: afmeting
    var afmeting = form.querySelector('[name="afmeting"]')?.value || '';
    if (afmeting === 'Anders') {
      var customCm = (form.querySelector('[name="afmeting_anders"]')?.value || '').trim();
      formData.append('afmeting', customCm ? customCm + 'cm' : 'Anders');
    } else {
      formData.append('afmeting', afmeting);
    }

    // Veld 5: locatie
    var locatie = form.querySelector('[name="locatie"]:checked');
    formData.append('locatie', locatie ? locatie.value : '');

    // Veld 6: timing
    var timing = form.querySelector('[name="timing"]:checked');
    formData.append('timing', timing ? timing.value : '');

    // Veld 7: contactgegevens
    var naamSubmit = splitNaam();
    formData.append('voornaam',   naamSubmit.voornaam);
    formData.append('achternaam', naamSubmit.achternaam);
    formData.append('email',           (form.querySelector('[name="email"]')?.value           || '').trim());
    formData.append('telefoon_prefix',  form.querySelector('[name="telefoon_prefix"]')?.value || '');
    formData.append('telefoon',        (form.querySelector('[name="telefoon"]')?.value        || '').trim());
    formData.append('bedrijfsnaam',    (form.querySelector('[name="bedrijfsnaam"]')?.value    || '').trim());

    // Veld 8: extra wensen
    formData.append('wensen', form.querySelector('[name="wensen"]')?.value || '');

    // Meta
    formData.append('bron', 'neon-sign-landing');
    if (partialLeadId) formData.append('partial_lead_id', partialLeadId);

    // Attributie: campagne/advertentie/zoekterm waar de lead vandaan komt
    var attributionSubmit = getAttribution();
    ATTRIBUTION_KEYS.forEach(function (k) {
      if (attributionSubmit[k]) formData.append(k, attributionSubmit[k]);
    });

    fetch(SUBMIT_API, { method: 'POST', body: formData })
      .then(function (response) {
        if (!response.ok) throw new Error('Server error: ' + response.status);
        return response.json();
      })
      .then(function (data) {
        sessionStorage.removeItem(STORAGE_KEY);
        partialLeadId   = '';
        uploadedFileUrl = '';

        // Conversie-events vuren op de thank-you pagina (betrouwbaarder dan
        // vlak voor een redirect). Het meta_lead_event_id zorgt daar voor
        // dedup tussen browser-pixel en server-side CAPI.
        try {
          sessionStorage.setItem('bf_lead_conversion', JSON.stringify({
            event_id: (data && data.meta_lead_event_id) || '',
            ts: Date.now()
          }));
        } catch (e) {}

        window.location.href = '/pages/thank-you/';
      })
      .catch(function (err) {
        formSubmitted = false;
        if (errorMsg) {
          errorMsg.textContent = 'Er is iets misgegaan bij het verzenden. Probeer het opnieuw of neem contact met ons op.';
          errorMsg.classList.add('is-visible');
        }
        console.error('Form submission error:', err);
      })
      .finally(function () {
        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = false;
      });
  });

  function resetForm() {
    form.reset();

    // Bestand
    selectedFile    = null;
    uploadedFileUrl = '';
    if (fileInput)     fileInput.value = '';
    if (uploadPreview) uploadPreview.classList.remove('is-visible', 'is-uploading');
    if (uploadArea)    uploadArea.style.display = '';
    if (uploadThumb) { uploadThumb.src = ''; uploadThumb.style.display = ''; }

    // Toggle kaarten resetten
    form.querySelectorAll('.neon-form__toggle-option').forEach(function (o) {
      o.classList.remove('is-active', 'is-active--purple');
    });
    // Locatie: eerste optie (Binnen) standaard actief
    var locOpt = form.querySelector('#neon-location-toggle .neon-form__toggle-option');
    if (locOpt) {
      locOpt.classList.add('is-active');
      var locRadio = locOpt.querySelector('input');
      if (locRadio) locRadio.checked = true;
    }

    // Timing resetten
    form.querySelectorAll('.neon-form__timing-option').forEach(function (o) {
      o.classList.remove('is-active');
    });

    // Conditionele velden verbergen
    updateConditionalFields();

    // Anders-veld verbergen
    if (andersWrap) { andersWrap.style.display = 'none'; }
    if (andersInput) { andersInput.value = ''; }
  }

  /* ==========================================================================
     FAQ ACCORDION
     ========================================================================== */

  var faqList = document.getElementById('neon-faq-list');
  if (faqList) {
    faqList.addEventListener('click', function (e) {
      var btn = e.target.closest('.neon-faq__question');
      if (!btn) return;
      var item   = btn.closest('.neon-faq__item');
      var isOpen = item.classList.contains('is-open');
      faqList.querySelectorAll('.neon-faq__item').forEach(function (el) {
        el.classList.remove('is-open');
        el.querySelector('.neon-faq__question').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

})();
